"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHART_COMPARE_MIN_N = exports.CHART_COMPARE_DOUBLE_MAX_SCHOOLS = exports.CHART_COMPARE_MAX_GROUPS = exports.CHART_COMPARE_LABEL_DE = exports.CHART_COMPARE_COLORS = exports.chartCompareGroups = exports.CHART_COMPARE_GROUPS = exports.CHART_BIRTH_YEAR_COLORS = exports.compareBirthYears = exports.birthYearOfKey = exports.birthYearKey = exports.CHART_BIRTH_YEAR_MAX = exports.CHART_BIRTH_YEAR_MIN = exports.CHART_BIRTH_YEAR_FILTER_MAX = exports.CHART_BIRTH_YEAR_COMPARE_MAX = exports.CHART_BIRTH_YEAR_COMPARE_MIN = exports.CHART_COMPARE_BY = void 0;
exports.compareGroupColor = compareGroupColor;
exports.compareGroupLabelDe = compareGroupLabelDe;
exports.chartCompareCombos = chartCompareCombos;
exports.compareRequestProblem = compareRequestProblem;
exports.compareAllHidden = compareAllHidden;
exports.mapCompareAllHidden = mapCompareAllHidden;
const chart_colors_1 = require("./chart-colors");
const weight_class_1 = require("./weight-class");
exports.CHART_COMPARE_BY = [
    "gender",
    "sportsClub",
    "weightClass",
    "birthYear",
];
/**
 * "Gegenüberstellen: Jahrgang" (Gerald 11/2026): the subgroups are the
 * years selected in the Jahrgang filter (at least 2, at most 6; more would
 * not fit the grouped bars). Children of other years or without a birth
 * date are the rest (no subgroup).
 */
exports.CHART_BIRTH_YEAR_COMPARE_MIN = 2;
exports.CHART_BIRTH_YEAR_COMPARE_MAX = 6;
/** Jahrgang filter: at most this many years in one request. */
exports.CHART_BIRTH_YEAR_FILTER_MAX = 20;
exports.CHART_BIRTH_YEAR_MIN = 1990;
exports.CHART_BIRTH_YEAR_MAX = 2100;
const birthYearKey = (year) => `Y${year}`;
exports.birthYearKey = birthYearKey;
/** The year of a Jahrgang key ("Y2016" -> 2016), null for other keys. */
const birthYearOfKey = (key) => (key && /^Y\d{4}$/.test(key) ? Number(key.slice(1)) : null);
exports.birthYearOfKey = birthYearOfKey;
/** The selected years of a Jahrgang comparison, sorted and deduplicated. */
const compareBirthYears = (years) => [...new Set(years ?? [])].sort((a, b) => a - b);
exports.compareBirthYears = compareBirthYears;
/**
 * Jahrgang colours by position in the sorted selection (Okabe-Ito,
 * colour-vision safe; distinct from Buben / Mädchen / Sportverein).
 */
exports.CHART_BIRTH_YEAR_COLORS = [
    "#0072B2",
    "#E69F00",
    "#009E73",
    "#D55E00",
    "#56B4E9",
    "#7B5EA7",
];
/** Subgroups in display order (left bar first). */
exports.CHART_COMPARE_GROUPS = {
    gender: ["MALE", "FEMALE"],
    sportsClub: ["YES", "NO"],
    // Weight class at the respective test; "keine Angabe" is in no subgroup.
    weightClass: weight_class_1.WEIGHT_CLASS_KEYS,
    // Dynamic: the selected years (`chartCompareGroups`).
    birthYear: [],
};
/** Subgroup keys of a dimension; Jahrgang = the selected `years`. */
const chartCompareGroups = (by, years) => by === "birthYear"
    ? (0, exports.compareBirthYears)(years).map(exports.birthYearKey)
    : exports.CHART_COMPARE_GROUPS[by];
exports.chartCompareGroups = chartCompareGroups;
/**
 * Gerald: Buben blue, Mädchen pink, Sportverein ja green, nein red; the
 * weight classes keep the colours of the Gewichtsklassifikation.
 */
exports.CHART_COMPARE_COLORS = {
    MALE: "#2F6DB5",
    FEMALE: "#E0559A",
    YES: "#2E8B57",
    NO: "#C8322B",
    ...chart_colors_1.CHART_WEIGHT_CLASS_COLORS,
};
exports.CHART_COMPARE_LABEL_DE = {
    MALE: "Buben",
    FEMALE: "Mädchen",
    YES: "Sportverein ja",
    NO: "Sportverein nein",
    ...weight_class_1.WEIGHT_CLASS_LABEL_DE,
};
/**
 * Colour of a subgroup. Jahrgang: by position of the year in `years` (the
 * selection of the request, see `ChartCompare.years`); without `years` by
 * the year itself (stable, but two years 6 apart share a colour).
 */
function compareGroupColor(key, years) {
    const year = (0, exports.birthYearOfKey)(key);
    if (year === null) {
        return (exports.CHART_COMPARE_COLORS[key] ??
            "#6B7280");
    }
    const sorted = (0, exports.compareBirthYears)(years);
    const i = sorted.indexOf(year);
    const n = exports.CHART_BIRTH_YEAR_COLORS.length;
    return exports.CHART_BIRTH_YEAR_COLORS[i >= 0 ? i % n : ((year % n) + n) % n];
}
/** German label of a subgroup ("Buben", "Jahrgang 2016"), PDF and logs. */
function compareGroupLabelDe(key) {
    const year = (0, exports.birthYearOfKey)(key);
    if (year !== null)
        return `Jahrgang ${year}`;
    return (exports.CHART_COMPARE_LABEL_DE[key] ?? key);
}
/**
 * Double comparison: at most this many subgroups (Jahrgang 6 x Geschlecht /
 * Sportverein 2, or Gewichtsklasse 5 x 2) and schools (1-4: panels; the
 * compact 5-20 table has no room for it). Jahrgang x Gewichtsklasse is
 * therefore possible with 2 years only.
 */
exports.CHART_COMPARE_MAX_GROUPS = 12;
exports.CHART_COMPARE_DOUBLE_MAX_SCHOOLS = 4;
/** Subgroups of a (double) comparison: key2 outer, key inner. */
function chartCompareCombos(by, by2, years) {
    const inner = (0, exports.chartCompareGroups)(by, years);
    if (!by2)
        return inner.map((key) => ({ key }));
    return (0, exports.chartCompareGroups)(by2, years).flatMap((key2) => inner.map((key) => ({ key, key2 })));
}
/**
 * Why a comparison request is not possible (null = ok): Jahrgang needs
 * 2..6 selected years; a double comparison at most
 * CHART_COMPARE_MAX_GROUPS subgroups. Used by the API (400) and the web
 * controls (disabled option with hint).
 */
function compareRequestProblem(by, by2, years) {
    if (!by)
        return null;
    const count = (0, exports.compareBirthYears)(years).length;
    if ((by === "birthYear" || by2 === "birthYear") &&
        (count < exports.CHART_BIRTH_YEAR_COMPARE_MIN ||
            count > exports.CHART_BIRTH_YEAR_COMPARE_MAX)) {
        return "birthYearCount";
    }
    if (by2 &&
        chartCompareCombos(by, by2, years).length > exports.CHART_COMPARE_MAX_GROUPS) {
        return "tooManyGroups";
    }
    return null;
}
/**
 * Super admin views: a subgroup cell (timepoint, or one feature mean) with
 * fewer children is sent without numbers ("n < 5"). Enforced in the backend.
 */
exports.CHART_COMPARE_MIN_N = 5;
/**
 * The privacy rules hid EVERY value of a comparison (e.g. the 3 x 3
 * all-or-nothing rule of Geschlecht x Sportverein in a small school): no
 * shown value, at least one hidden cell. Fitnesswerte: at `timepoint`;
 * Gewichtsklassifikation: over all timepoints. The views then show the note
 * "Zu wenige Kinder für diese Gegenüberstellung" instead of an empty plot.
 */
function compareAllHidden(compare, mode, timepoint) {
    const cells = compare.groups.flatMap((g) => g.timepoints.filter((tp) => mode === "weight" || tp.key === timepoint));
    if (mode === "weight") {
        return (!cells.some((c) => c.weight !== null) &&
            cells.some((c) => c.suppressed || (c.n ?? 0) > 0));
    }
    const shown = cells.some((c) => !c.suppressed && Object.values(c.means).some((v) => v !== null));
    const hidden = cells.some((c) => c.suppressed || Object.values(c.meanN).some((n) => n === null));
    return !shown && hidden;
}
/**
 * Map / drill-down "Gegenüberstellen": every subgroup of every region (or
 * school point) with data is hidden, nothing is shown. `schools` = 0 marks a
 * region without schools (not hidden, just empty).
 */
function mapCompareAllHidden(cells) {
    const shown = cells.some((c) => !c.suppressed && c.value !== null);
    const hidden = cells.some((c) => c.suppressed && (c.schools === undefined || c.schools > 0));
    return !shown && hidden;
}
